import { Spacer, Text } from 'components';
import classNames from 'classnames';
import React, { memo } from 'react';
import styles from './Table.module.scss';
import TableRow, { TableRowProps } from './TableRow';

type Props = {
  items: TableRowProps[];
  className?: string;
  title?: string;
};

export const Table = memo(function Table({ className, items, title }: Props) {
  return (
    <>
      {title && (
        <Spacer paddingBottom="20px" className={styles.title}>
          <Text weight="bold" text={title} />
        </Spacer>
      )}
      <div
        className={classNames(
          styles['table-rows'],
          title && styles['with-title'],
          className,
        )}
      >
        {items.map((item) => (
          <TableRow key={item.label} {...item} />
        ))}
      </div>
    </>
  );
});
